import React from 'react';

import './require-feature.scss';

/** Small lock glyph used as the tab "dot" for plan-locked marketplace tabs. */
export const LockDot = () => (
  <svg width="10" height="10" viewBox="0 0 12 12" fill="none" aria-label="Locked" style={{ opacity: 0.7 }}>
    <rect x="2.5" y="5.5" width="7" height="5" rx="1" stroke="currentColor" strokeWidth="1.2" />
    <path d="M4 5V3.8C4 2.7 4.9 1.8 6 1.8C7.1 1.8 8 2.7 8 3.8V5" stroke="currentColor" strokeWidth="1.2" />
  </svg>
);

/**
 * Rendered inside the listing form when a plan-locked marketplace tab is
 * selected (Alex, 2026-08-13: locked tabs, not hidden). Explains the lock —
 * no dead form fields, and no upgrade request (Alex, 2026-10-28).
 */
export function LockedTabPanel({ label }) {
  return (
    <div className="rc-locked-tab">
      <div className="rc-locked-feature__icon" aria-hidden="true">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <rect x="5" y="10.5" width="14" height="9" rx="2" stroke="currentColor" strokeWidth="1.6" />
          <path d="M8 10V7.5C8 5.3 9.8 3.5 12 3.5C14.2 3.5 16 5.3 16 7.5V10" stroke="currentColor" strokeWidth="1.6" />
        </svg>
      </div>
      <h4>{label} sync is not included in your store&apos;s current plan</h4>
      <p>
        Your listings and their {label} settings are kept safe — everything
        reactivates exactly as it was when the feature is added to your plan.
      </p>
    </div>
  );
}

export default LockedTabPanel;
